import { Injectable, inject } from '@angular/core';
import { Country } from '@wdx/clmi/clmi-swagger-gen';
import { CountryNonpagedApiService } from '@wdx/clmi/clmi-swagger-gen/api-services';
import { Observable } from 'rxjs';

@Injectable()
export class CountriesService {
    private countryNonpagedApiService = inject(CountryNonpagedApiService);

    getCountries(): Observable<Country[]> {
        return this.countryNonpagedApiService.get();
    }
}
